import apiClient from "services/apiClient";

async function changeImportStatus(id: number, body?: any) {
    const res = await apiClient.put(`/admin/imports/${id}/undo-and-archive`);
    return res.data;
}

export default changeImportStatus;
